"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const stdGrid_1 = require("views/stdGrid");
const globals_1 = require("models/globals");
const menuButtons_1 = require("../models/menuButtons");
const articles_1 = require("../models/articles");
const rules_1 = require("../outils/rules");
webix.editors.$popup.text = {
    view: "popup",
    body: {
        view: "textarea",
        width: 420,
        height: 120,
        attributes: { maxLength: 250 }
    }
};
class Articles extends stdGrid_1.default {
    constructor(app, name) {
        super(app, name, {
            datatableName: "articlesdatatable",
            columns: articles_1.articlesColumns,
            title: (0, globals_1._)("Liste des produits"),
            boutons: [menuButtons_1.ajouterButton, menuButtons_1.dupliquerButton, menuButtons_1.supprimerButton],
            resizeColumn: true,
            searchFieldHint: (0, globals_1._)("Recherche désignation ..."),
            urlData: globals_1.phpPath + "articles.php?option=list",
            saveData: {
                updateFromResponse: true,
                "insert": globals_1.phpPath + "articles.php?option=insertEmpty",
                "update": globals_1.phpPath + "articles.php?option=update",
                "delete": globals_1.phpPath + "articles.php?option=delete",
            },
            scheme: {
                $export: function (obj) {
                    return { value: obj.value, number: webix.i18n.numberFormat(obj.number) };
                }
            },
            // Les contrôles simples sont ici
            rules: {
                idNature: webix.rules.isNotEmpty,
                codeArticle: webix.rules.isNotEmpty,
                prixAchat: rules_1.rulePrixPositif,
                prixVente: rules_1.rulePrixPositif
            }
        });
    }
    /* Surcharge de la méthode de StdGrid */
    ajouter() {
        let data = this.defaultValues;
        let view = this.currentGrid;
        view.editStop();
        let index = 0;
        if (view.getSelectedId(false, false)) {
            index = view.getIndexById(view.getSelectedId(false, false));
        }
        view.add(webix.copy(data), index); // le copy est indispensable, sinon à la prochaine itération il contient tout l'enregistrement
        view.unselectAll();
        view.editCell(view.getIdByIndex(index), "codeArticle");
    }
    tune(tuner) {
        if (tuner.defaultValues) {
            this.defaultValues = tuner.defaultValues;
        }
    }
    dupliquer() {
        super.dupliquer("codeArticle");
    }
    imprimerTableDistant() {
        webix.message((0, globals_1._)("Génération du fichier pdf en cours"));
        // @ts-ignore
        webix.ajax().response("blob").get(globals_1.phpPath + "/printing/articles.php", function (text, data) {
            // @ts-ignore
            webix.html.download(data, "listeArticles.pdf");
        });
    }
    afterSaveError(id, status, response) {
        webix.alert(response.message);
    }
    init(baseview) {
        this.moduleName = "articles";
        super.init(baseview);
        let me = this;
        // Maintenant j'applique les personnalisations.
        // Je charge les personnalisations
        // @ts-ignore
        let promise = webix.ajax().get(globals_1.phpPath + "parametres.php?key=articles.form&option=readjson");
        promise.then(function (result) {
            me.tune(result.json());
        });
        // fonction de recherche article
        this.searchField = $$("search");
        this.searchField.show();
        this.searchField.attachEvent("onTimedKeyPress", function () {
            let value = this.getValue().toLowerCase();
            me.currentGrid.filter(function (obj) {
                if (obj.designation) {
                    let odesignation = obj.designation.toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                    return odesignation.toLowerCase().indexOf(value) != -1;
                }
                return 0;
            });
        });
        // autres fonctions
        let menu = this.$$("stdGridMenu");
        menu.attachEvent("onMenuItemClick", function (id, e, node) {
            switch (id) {
                case "button-add":
                    me.ajouter();
                    break;
                case "button-del":
                    me.supprimer();
                    break;
                case "button-dup":
                    me.dupliquer();
                    break;
            }
        });
        // autres fonctions génériques
        $$("imprimerTableDistantButton").show();
        $$("articlesImprimerTableButton").show();
        // webix.extend($$(this.datatableName), webix.ProgressBar);     Pourquoi faire ?
    }
    ready() {
        let menu = this.$$("stdGridMenu");
        menu.hideMenuItem("button-add");
        menu.hideMenuItem("button-del");
        menu.hideMenuItem("button-dup");
        if ((globals_1.lv2.droits).includes(this.moduleName + ".insertEmpty,")) {
            menu.showMenuItem("button-add");
            menu.showMenuItem("button-dup");
        }
        if ((globals_1.lv2.droits).includes(this.moduleName + ".delete,")) {
            menu.showMenuItem("button-del");
        }
        let me = this;
        let dtable = this.currentGrid;
        dtable.validate();
        let dp = webix.dp(dtable);
        dp.attachEvent("onBeforeSaveError", function (id, status, response) {
            me.afterSaveError(id, status, response);
        });
        // pour les utilisateurs qui tapent une virgule à la place du point
        // ou qui mettent plus de deux décimales sur un montant
        dtable.attachEvent("onBeforeEditStop", function (state, editor, ignore) {
            if (editor.column == "prixVente") {
                state.value = globals_1.lv2.verifMontant(state.value);
            }
            if (editor.column == "prixAchat") {
                state.value = globals_1.lv2.verifMontant(state.value);
            }
            if (editor.column == "codeArticle") {
                state.value = globals_1.lv2.verifTexte(state.value);
            }
            if (editor.column == "designation") {
                state.value = globals_1.lv2.verifTexte(state.value);
            }
        });
        dtable.attachEvent("onValidationError", function (id, obj, details) {
            let text = [];
            for (let key in details) {
                if (key == "idNature")
                    text.push((0, globals_1._)("Le code nature est obligatoire"));
                if (key == "codeArticle")
                    text.push((0, globals_1._)("Le code produit est obligatoire"));
                if (key == "prixAchat")
                    text.push((0, globals_1._)("Un produit ne peut pas avoir un prix d'achat négatif"));
                if (key == "prixVente")
                    text.push((0, globals_1._)("Un produit ne peut pas avoir un prix de vente négatif"));
                if (key == "idTVA")
                    text.push((0, globals_1._)("Le code TVA est obligatoire sauf pour les commentaires"));
            }
            webix.message({ type: "error", text: text.join("<br>") });
        });
        dtable.attachEvent("onAfterEditStop", function (state, editor, ignoreUpdate) {
            let item = this.getItem(editor.row);
            // vider les champs inutiles s'il s'agit d'un commentaire
            if (item.idNature == 3) {
                if (item.prixVente || item.prixAchat || item.idTVA) {
                    webix.message({ type: "error", text: (0, globals_1._)("Un produit de type 'Commentaire' ne peut pas avoir de prix ou de code TVA") });
                    this.updateItem(editor.row, {
                        prixVente: "",
                        prixAchat: "",
                        idTVA: ""
                    });
                    // this.editCell(editor.row,"codeArticle");
                }
            }
            // vérifier que le prix de vente est supérieur au prix d'achat
            if (editor.column == "prixAchat" || editor.column == "prixVente") {
                if (Number(item.prixAchat) > Number(item.prixVente)) {
                    webix.message({ type: "error", text: (0, globals_1._)("Le prix de vente est inférieur au prix d'achat") });
                }
            }
            // vérifier que le code article n'est pas déjà utilisé
            if (editor.column == "codeArticle") {
                if (state.value.length > 0) {
                    let req = globals_1.phpPath + "articles.php?key=codeArticle&option=unique&value=" + state.value +
                        "&unid=" + item.unid;
                    // @ts-ignore
                    let promise = webix.ajax().get(req);
                    promise.then(function (result) {
                        if (result.json().success == true) {
                        }
                        else {
                            webix.message({ type: "error", text: (0, globals_1._)("Ce code produit est déjà utilisé : ") + item.codeArticle });
                            item.codeArticle = "";
                            dtable.updateItem(editor.row, item);
                            dtable.editCell(editor.row, "codeArticle");
                        }
                    });
                }
            }
        });
    }
}
exports.default = Articles;
